import { useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/lib/auth";

export default function ProtectedRoute({ children, roles }) {
  const { user, loading } = useAuth();
  const loc = useLocation();
  const unauthorized = !!user && !!roles && !roles.includes(user.system_role);

  // Fire a single toast when the user lands on a route they cannot access.
  // useEffect guarantees the toast runs as a side-effect — not during render —
  // so the redirect below works cleanly and the toast persists onto the Dashboard.
  useEffect(() => {
    if (unauthorized) {
      toast.error("You don't have permission to access that page.");
    }
  }, [unauthorized, loc.pathname]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center text-sm text-neutral-500">
        Loading…
      </div>
    );
  }
  if (!user) return <Navigate to="/login" state={{ from: loc }} replace />;
  if (unauthorized) return <Navigate to="/" replace />;
  return children;
}
